import { render, staticRenderFns } from "./CytomineProperties.vue?vue&type=template&id=622ccbbd&scoped=true"
import script from "./CytomineProperties.vue?vue&type=script&lang=js"
export * from "./CytomineProperties.vue?vue&type=script&lang=js"
import style0 from "./CytomineProperties.vue?vue&type=style&index=0&id=622ccbbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ccbbd",
  null
  
)

export default component.exports